import { render, staticRenderFns } from "./createitem.vue?vue&type=template&id=6df2be82"
import script from "./createitem.vue?vue&type=script&lang=js"
export * from "./createitem.vue?vue&type=script&lang=js"
import style0 from "./createitem.vue?vue&type=style&index=0&id=6df2be82&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports